
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Downloads2 } from "@components/download2";
import { NextSeo } from "@components/seo";
import Image from "next/image";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
import { PAGE } from "../consts/ppages";
import { getAdvertisePageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        advertise: {
            pvc: {
                catalogs: {
                    name: string;
                    icon: {
                        sourceUrl: string;
                    };
                    file: {
                        mediaItemUrl: string;
                    };
                }[];
                flyers: [
                ];
            };
            alu: {
                catalogs: [
                ];
                flyers: [
                ];
            };
        };
        downloads: {
            downloads: {
                name: string;
                icon: {
                    sourceUrl: string;
                };
                file: {
                    mediaItemUrl: string;
                };
            }[];
        };
    };
}
const AdvertisingMaterials: NextPage<IPage> = ({ page }) => {
    const { t } = useTranslation("common");
    return (<>
      <NextSeo languageAlternates={[
            {
                href: "https://knsokna.pl/advertising-materials",
                hrefLang: "x-default",
            },
            {
                href: "https://knswindows.com/advertising-materials",
                hrefLang: "en",
            },
            { href: "https://knsokna.pl/advertising-materials", hrefLang: "pl" },
            {
                href: "https://knsfenster.de/advertising-materials",
                hrefLang: "de",
            },
            { href: "https://kns-okna.eu/advertising-materials", hrefLang: "cs" },
            {
                href: "https://knsfinestre.it/advertising-materials",
                hrefLang: "it",
            },
            {
                href: "https://knsfenetres.fr/advertising-materials",
                hrefLang: "fr",
            },
            { href: "https://knsokna.eu/advertising-materials", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl">
          <Image alt="advertise" height="599" src="/img/advertise.webp" width="1600"/>
        </div>
        <div className="mx-auto max-w-7xl px-2 py-2 xl:px-0">
          <div className="py-3 text-center">
            <span className="bg-gradient-to-r from-red to-orange px-3 py-1 font-bold text-lg text-white uppercase">
              {t("products.pvc")}
            </span>
          </div>
          <div className="bg-gray-100 p-2 text-sm">KATALOGI</div>
          <Downloads2 downloads={page?.advertise.pvc.catalogs}/>
          <div className="bg-gray-100 p-2 text-sm">ULOTKI</div>
          <Downloads2 downloads={page?.advertise.pvc.flyers}/>
        </div>
        <div className="mx-auto max-w-7xl px-2 py-2 xl:px-0">
          <div className="py-3 text-center">
            <span className="bg-gradient-to-r from-red to-orange px-3 py-1 font-bold text-lg text-white uppercase">
              {t("products.alu")} | {t("products.rollers")}
            </span>
          </div>
          <div className="bg-gray-100 p-2 text-sm">KATALOGI</div>
          <Downloads2 downloads={page?.advertise.alu.catalogs}/>
          <div className="bg-gray-100 p-2 text-sm">ULOTKI</div>
          <Downloads2 downloads={page?.advertise.alu.flyers}/>
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.ADVERTISE_MATERIALS[LOCALE as keyof typeof PAGE.ADVERTISE_MATERIALS] ||
        1;
    const { page } = await getAdvertisePageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default AdvertisingMaterials;

    async function __Next_Translate__getStaticProps__1a19cd2bec3__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/advertising-materials',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bec3__ as getStaticProps }
  